import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const requiredFields = [
  { key: 'email', label: 'Email' },
  { key: 'full_name', label: 'Full Name' },
  { key: 'company', label: 'Company' },
  { key: 'role_title', label: 'Role' }
] as const;

interface CSVMappingDialogProps {
  showMappingDialog: boolean;
  setShowMappingDialog: (show: boolean) => void;
  csvHeaders: string[];
  columnMapping: Record<string, string>;
  setColumnMapping: (mapping: Record<string, string>) => void;
  isUploading: boolean;
  handleFileUpload: () => void;
}

export const CSVMappingDialog = ({
  showMappingDialog,
  setShowMappingDialog,
  csvHeaders,
  columnMapping,
  setColumnMapping,
  isUploading,
  handleFileUpload
}: CSVMappingDialogProps) => {
  const handleMappingChange = (field: string, value: string) => {
    setColumnMapping({
      ...columnMapping,
      [field]: value
    });
  };

  return (
    <Dialog open={showMappingDialog} onOpenChange={setShowMappingDialog}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Map CSV Columns</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          {requiredFields.map((field) => (
            <div key={field.key} className="grid grid-cols-4 items-center gap-4">
              <label htmlFor={field.key} className="text-right">
                {field.label}
              </label>
              <div className="col-span-3">
                <Select
                  value={columnMapping[field.key]}
                  onValueChange={(value) => handleMappingChange(field.key, value)}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select column" />
                  </SelectTrigger>
                  <SelectContent>
                    {csvHeaders.map((header) => (
                      <SelectItem key={header} value={header}>
                        {header}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button onClick={() => setShowMappingDialog(false)} variant="outline">
            Cancel
          </Button>
          <Button 
            onClick={handleFileUpload} 
            disabled={isUploading || Object.keys(columnMapping).length !== requiredFields.length}
          >
            {isUploading ? 'Uploading...' : 'Upload'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};